import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { reportData } from "../../data/reportData";
import styles from "./css/ReportChart.module.scss";
ChartJS.register(ArcElement, Tooltip, Legend);

const REASON_COLORS = [
  "#403D68",
  "#407022",
  "#2A70A8",
  "#FFB703",
  "#F97316",
  "#E63946",
  "#2A9D8F",
  "#E9C46A",
  "#264653",
  "#8338EC",
];

const totalReports = reportData.reduce((acc, item) => acc + item.value, 0);

const data = {
  labels: reportData.map((item) => item.label),

  datasets: [
    {
      data: reportData.map((item) => item.value),
      backgroundColor: reportData.map((item) => item.color),
      borderWidth: 0,
      cutout: "68%",
    },
  ],
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
    },
  },
};

const ReportChart = ({ reasonBreakdown = [], totalReports = 0, colorMap }) => {
  const getColor = (reason, i) =>
    colorMap[reason] ?? REASON_COLORS[i % REASON_COLORS.length];

  const data = {
    labels: reasonBreakdown.map((item) => item.reason),
    datasets: [
      {
        data: reasonBreakdown.map((item) => item.count),
        backgroundColor: reasonBreakdown.map((item, i) =>
          getColor(item.reason, i),
        ),
        borderWidth: 0,
        cutout: "68%",
      },
    ],
  };

  return (
    <div className={styles.chart_card}>
      <div className={styles.chart_wrapper}>
        <Doughnut data={data} options={options} />
        <div className={styles.chart_center}>
          <p>Total Reports</p>
          <h2>{totalReports}</h2>
        </div>
      </div>

      {/* LEGEND */}
      <div className={styles.legend}>
        {reasonBreakdown.map((item, index) => (
          <div className={styles.legend_item} key={index}>
            <div className={styles.legend_left}>
              <span
                className={styles.legend_dot}
                style={{
                  background: getColor(item.reason, index),
                }}
              />
              <p>{item.reason}</p>
            </div>

            <span className={styles.legend_value}>{item.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportChart;
